import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Miscellaneous Receipts';
export const MiscRoutes = [
  {
    path: '/misc',
    name: 'MiscellaneousReceipts',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/MiscellaneousReceipt.vue'),
    children: [
      {
        path: 'transactions',
        name: 'Miscellaneous Receipts - Transactions',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/Misc/Transactions.vue'),
      },
      {
        path: 'reports',
        name: 'Miscellaneous Receipts - Reports',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/Misc/Reports.vue'),
      },
      {
        path: 'browse',
        name: 'Miscellaneous Receipts - Browse',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/Misc/browse/browse.vue'),
        children: [
          {
            path: 'unitschoolcode',
            name: 'Miscellaneous Receipts - Unit/School Code',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/Misc/browse/UnitSchoolCode.vue'),
          },
          {
            path: 'receivedof',
            name: 'Miscellaneous Receipts - Received Of',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/common/Whom.vue'),
          },
        ],
      },
      {
        path: 'utils',
        name: 'Miscellaneous Receipts - Utils',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/Misc/utils/MiscUtils.vue'),
        children: [
          {
            path: 'createfiscalyear',
            name: 'Miscellaneous Receipts - Create Fiscal Year',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/Misc/utils/MiscellaneousCreateFiscalYear.vue'),
          },
        ],
      },
    ],
  },
];

MiscRoutes.forEach((element, index) => {
  MiscRoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria(authRoles.MiscRead, next);
  };
});

export default MiscRoutes;
